module.exports = __webpack_public_path__ + "img/path.9d93f36f.svg";